/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { Spacer } from '~/modules/coreUI/components/legacies/Spacers';

import { Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import WishButton from '~/modules/ecommerceCoreUI/components/productDetails/vendor/buttons/WishButton';
import CompareButton from '~/modules/ecommerceProducts/components/compare/CompareButton';

const ActionButtons = ({ itemInfo }) => (
  <Row className="assets">
    {!itemInfo.has_offer && <CompareButton variantID={itemInfo.root_variant_id || itemInfo.ref_id} />}
    <Spacer size={10} />
    <WishButton wishListed={itemInfo.root_variant?.wish_listed || itemInfo.wish_listed} variantId={itemInfo.ref_id} />
  </Row>
);

ActionButtons.propTypes = {
  itemInfo: PropTypes.shape({}).isRequired,
};

export default ActionButtons;
